import 'jquery-address';
import './DonationForm.js';
import './main.js';

import '../Sass/style.scss';